module.exports = __webpack_public_path__ + "img/19.963fcbe2.jpg";